import { message, Popover, Space, Switch, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {baseUrl} from "../../../../src/config"
export const Reviews=()=>{
const [reviews,setReviews]=useState([])

     
const { Column, ColumnGroup } = Table;

interface DataType {
  key: React.Key;
  firstName: string;
  lastName: string;
  age: number;
  address: string;
  tags: string[];
}
const storedData = localStorage.getItem("loginData");
const loginData = JSON.parse(storedData);
const navigate=useNavigate()
    useEffect(() => {
        const storedData = localStorage.getItem("loginData");
        if (storedData) {
            // Parse the data into an object
            const loginData = JSON.parse(storedData);
          
            // Access the id from the stored data
            const userId = loginData.id;
          
            console.log("User ID:", userId);
          } else {
            console.log("No login data found");
          }
        getReviews();
      }, []);
    
      const getReviews = async () => {
        try {
          const resp = await axios.get(
            `${baseUrl}account/${loginData.id}/reviews?query=all`,
            {
              headers:{
                  Authorization:`Bearer ${loginData.authToken}`
              }
          }
          );
          console.log(resp.data); // Log the response to check
        
          setReviews(resp?.data);
        } catch (e) {
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          console.error(e);
        }
      }

      const updateReview = async (record,val) => {
        try {
          const resp = await axios.put(
            `${baseUrl}account/${loginData.id}/review/update`,{
              id:record?.id,
              isVisible:val
            },{
                headers:{
                    Authorization:`Bearer ${loginData.authToken}`
                }
            }
          );
          if(resp){
            
            message.success("Review updated successfully")
            getReviews()
          }
        
        } catch (e) {
          console.error(e);
           if(e.response.status==401){
                          navigate("/admin/login")
                      }
          message.error("Failed to update review")
        }
      }
    return(
      <div>
      <div style={{ textAlign: "center", fontSize: 28, fontWeight: 600, width: "100%", marginBottom: 24 }}>
  Reviews
</div>
      <Table<DataType> dataSource={reviews}  pagination={{ pageSize: 20 }}>
<Column title="Name" dataIndex="name" key="name" />
<Column title="Company Name" dataIndex="companyName" key="companyName" />
<Column
title="Review"
dataIndex="review"
key="review"
render={(review: string) => (
 <>
<Popover content={<div>{review}</div>} trigger="click" ><div style={{color:"green",cursor:"pointer"}}>View review</div></Popover>
 </>
)}
/>
<Column
title="Profile"
dataIndex="profile"
key="profile"
render={(profile: string) => (
 <>
<Popover content={<div>{profile ?<img src={profile} style={{width:"200",height:"200px"}}></img>:"No Data"}</div>} trigger="click" ><div style={{color:"#b60063",cursor:"pointer"}}>View profile</div></Popover>
 </>
)}
/>
<Column
title="Action"
key="action"
render={(_: any, record: any) => (
 <Space size="middle">
   <a ><Switch value={record?.isVisible} onChange={(val)=>updateReview(record,val)}></Switch></a>
 </Space>
)}
/>
</Table>
 </div>
    )
}